module.exports = __webpack_public_path__ + "static/hub-product-6779a9eb66951483a8fc5c1635700cfa.png";